export const mediaCapabilitiesConfig = {
  initDataTypes: ['cenc'],
  audioCapabilities: [{ contentType: 'audio/mp4;codecs="mp4a.40.2"' }],
  videoCapabilities: [
    { contentType: 'video/mp4;codecs="avc1.42C01E"' },
    { contentType: 'video/mp4;codecs="avc1.42C01F"' },
    { contentType: 'video/mp4;codecs="avc1.64001F"' },
    { contentType: 'video/mp4;codecs="avc1.640028"' },
    { contentType: 'video/mp4;codecs="avc1.640029"' },
  ],
};

/**
 * Return if either the hardware protection is supported or not for requested settings
 *
 * @param {string} system Name of the DRM protection system
 * @param {Object} robustness
 * @param {string} robustness.audio
 * @param {string} robustness.video
 * @return {Promise<boolean>} Result of device capabilities
 */
export const isDecryptAccessSupported = async (system, robustness) => {
  try {
    const mediaKeySystemAccess = await navigator.requestMediaKeySystemAccess(system, [
      {
        ...mediaCapabilitiesConfig,
        audioCapabilities: mediaCapabilitiesConfig.audioCapabilities.map(capability => ({
          ...capability,
          robustness: robustness.audio,
        })),
        videoCapabilities: mediaCapabilitiesConfig.videoCapabilities.map(capability => ({
          ...capability,
          robustness: robustness.video,
        })),
      },
    ]);
    await mediaKeySystemAccess.createMediaKeys();

    return true;
  } catch (error) {
    return false;
  }
};

export const fetchUpfrontToken = async handler => {
  if (!handler) {
    throw new Error('No DRM token handler provided');
  }
  const token = await handler();
  if (!token || !token.value) {
    throw new Error('DRM token endpoint returned no data');
  }

  return token;
};
